export enum EVENT {
    NEXT_STEP = 'rq-next-step',
    PREVIOUS_STEP = 'rq-previous-change',
    MANUAL_STEP = 'rq-manual-step',
    SUBMIT = 'rq-submit',
    UPDATE_FORM = 'rq-update-form',
    REMOVE_MEMBER = 'rq-remove-member',
    CHANGE_PAGE = 'rq-change-page',
    UPDATE_RESPONSE = 'rq-update-response',
    COMPARE_SELECTION = 'rq-compare-selection',
    COMPARE_BAR_REMOVAL = 'rq-compare-bar-removal',
    SET_FILTER_SORT = 'rq-set-filter-sort',
    CLOSE_FILTERS = 'rq-close-filters',
    RECOMMEND_PLAN = 'rq-recommend-plan',
    EDIT_INFO = 'rq-edit-info',
    SELECT_PLAN = 'rq-select-plan',
    SCROLL_TO_TOP = 'rq-scroll-to-top',
    CHECKBOX_CLICK = 'rq-checkbox-click',
    QUOTE_SAVED = 'rq-quote-saved',
    EMBEDDED_AGENT_SAVE_QUOTE = 'rq-save-quote',
}

export function makeCustomEvent(event: EVENT, detail?: unknown) {
    return new CustomEvent(event, { detail, composed: true, bubbles: true });
}
